export class Storage {
}
Storage.REMOTE_BASE_URL = process.env.MIX_APP_URL || 'https://www.sharementors.dev';
Storage.RECAPTCHA_SITE_KEY = process.env.MIX_RECAPTCHA_SITE_KEY;
Storage.STRIPE_PUBLIC_KEY = process.env.MIX_STRIPE_PUBLIC_KEY;
